import { ClassicEditor } from "ckeditor5"
import editorConfig from "./ckeditor"

$(function() {
  var editor = document.getElementById("notice_message_text")
  if (editor) ClassicEditor.create(editor, editorConfig)
})
